import React from 'react';

export default () => (
  <div className='w-5 h-5 border-[3px] border-white/50 border-t-[3px] border-t-white rounded-full animate-spin' />
);
